import { checkStatus, get, post } from '@/app/core/request';
import { CheckoutRoutes } from '@/app/api-routes';
import PaymentData from '@/types/store/checkout/PaymentData';

interface PreparePaymentResult {
  id?: string;
  url?: string;
  type?: string;
}

interface FreeCheckoutResult {
  finalized: boolean;
}

class CheckoutApi {
  async freeCheckout(orderId: string | null): Promise<FreeCheckoutResult> {
    return post<FreeCheckoutResult>(CheckoutRoutes.freeCheckout, {
      orderId
    });
  }
  async getPaymentMethods(communeId: number): Promise<any> {
    return get<string[]>(CheckoutRoutes.paymentMethods(String(communeId)));
  }
  async getPaymentEntryPage(orderId: string, paymentMethod: string, localeSelected: string): Promise<string> {
    return fetch(CheckoutRoutes.startPayment(orderId, paymentMethod, localeSelected))
      .then(checkStatus)
      .then(response => response.text());
  }
  async preparePayment(orderId: string | null, paymentMethod: string | null): Promise<PreparePaymentResult> {
    return post<PreparePaymentResult>(CheckoutRoutes.preparePayment, {
      orderId,
      paymentMethod,
    });
  }
  async directPayment(paymentData: PaymentData): Promise<any> {
    return post<any>(CheckoutRoutes.directPayment, paymentData);
  }
  async verifyPayment(
    checkoutId: string,
    checkoutResourcePath: string,
    orderId: string,
    paymentMethod: string
  ): Promise<string> {
    return post<any>(CheckoutRoutes.verifyPayment, {
      checkoutId,
      checkoutResourcePath,
      orderId,
      paymentMethod,
    })
      .then(response => {
        return response;
      })
      .then(({ message }) => message);
  }
  async saveCommuneMailConsent(orderId: string | null, communeMailConsent: boolean): Promise<any> {
    if (!orderId || !communeMailConsent) {
      return;
    }
    return post<any>(CheckoutRoutes.consentStoring, {orderId, communeMailConsent});
  }
}

export default new CheckoutApi();
